<template>
  <div v-if="data" class="relative h-full pb-4 overflow-x-auto bg-white">
    <table class="w-full text-sm text-left text-gray-900 divide-y divide-gray-200">
      <tbody>
        <BaseDetailsTableRow
          :name="$t('baseObject.name')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseInput
            :mode="mode"
            v-model="data.name"
            color="base"
            flat
            :disabled="mode == 'view'"
            show-error-as-tooltip
            :error="nameErrorMessage" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('baseObject.code')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseInput
            :mode="mode"
            v-model="data.code"
            color="base"
            flat
            :disabled="mode == 'view'"
            show-error-as-tooltip
            :error="codeErrorMessage" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :mode="mode"
          :name="$t('device.remarks')"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseInput
            :mode="mode"
            v-model="data.remarks"
            color="base"
            flat
            :disabled="mode == 'view'" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('baseObject.isActive')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseTableCellStatus v-if="mode == 'view'" :item="data.isActive ? data.isActive : 0" />
          <BaseToggle v-else name="isActive" v-model="data.isActive" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('baseObject.isFromManager')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseTableCellStatus
            :item="data.isFromManager ? data.isFromManager : 0"
            :textTrue="$t('common.actions.yes')"
            :textFalse="$t('common.actions.no')" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('device.lastLogin')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          {{ isoDateToFullDate(data.lastLogin) || '-' }}
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('baseObject.lastUpdate')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          {{ isoDateToFullDate(data.lastUpdate) || '-' }}
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('baseObject.updateUser')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          {{ data.updateUser?.name || '-' }}
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('baseObject.createdDate')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          {{ isoDateToFullDate(data.createdDate) || '-' }}
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('baseObject.createUser')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          {{ data.createUser?.name || '-' }}
        </BaseDetailsTableRow>
      </tbody>
    </table>
  </div>
</template>

<script setup lang="ts">
import { isoDateToFullDate } from '@/utils/date';
import BaseTableCellStatus from '../common/BaseTableCellStatus.vue';
import BaseInput from '../common/BaseInput.vue';
import BaseDetailsTableRow from '../common/BaseDetailsTableRow.vue';
import BaseToggle from '../common/BaseToggle.vue';
import { type Device } from '@/types/Device';

defineProps<{
  mode: 'view' | 'edit';
  isHorizontalLayout: boolean;
  codeErrorMessage: string;
  nameErrorMessage: string;
}>();

const data = defineModel<Device>();
</script>
